<template>
  <BaseElSelect
    v-model="syncModel"
    filterable
    remote
    :multiple="multiple"
    clearable
    v-bind="$attrs"
    reserve-keyword
    no-match-text="無匹配項目"
    no-data-text="暫無數據"
    :remote-method="remoteSearch"
    :loading="loading"
    value-key="id"
    style="height: 100%;"
    @change="$emit('change', $event)"
    @clear="$emit('clear')"
    @visible-change="onVisibleChange"
  >
    <i slot="prefix" class="el-input__icon el-icon-search" />
    <BaseElSelectOption
      v-for="(item, index) in dataList"
      :key="`${index} - ${item.name}`"
      :label="item.name"
      :value="getValue(item)"
    />
    <template #suffix>
      /
    </template>
  </BaseElSelect>
</template>
<script>
import { useShop } from '@/use/shop'
import { useFetch } from '@/use/fetch'
import { useVModel } from '@vueuse/core'
import { onMounted, ref } from 'vue'
import { orderBy } from 'lodash'

export default {
  name: 'BaseSearch',
  props: {
    value: [String, Number, Array, Object],
    objKey: String,
    multiple: Boolean,
    api: {
      type: Function,
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
    optionFormatter: Function,
    sortKey: String,
    sortOrder: {
      type: String,
      default: 'asc',
      validator: (value) => ['asc', 'desc'].includes(value),
    },
  },
  emits: ['update:value', 'change', 'clear', 'visibleChange'],
  setup (props, { emit }) {
    const loading = ref(false)
    const dataList = ref([])
    const { shopId } = useShop()
    const { fetchAll } = useFetch()
    const syncModel = useVModel(props, 'value', emit)

    const getDataList = async (nameSearch) => {
      loading.value = true

      await fetchAll(
        props.api,
        {
          shopId: shopId.value,
          ...props.filter,
          name: nameSearch || undefined,
        },
        (allData) => {
          let finalData = props.optionFormatter ? props.optionFormatter(allData) : allData

          if (props.sortKey) {
            finalData = orderBy(finalData, [props.sortKey], [props.sortOrder])
          }

          dataList.value = finalData
        },
      )

      loading.value = false
    }

    const remoteSearch = async (query) => {
      query = query.trim()
      if (!query) dataList.value = []

      try {
        setTimeout(async () => {
          await getDataList(query)
        }, 200)
      } catch (error) {
        console.log(error)
      }
    }

    // 確保每次重新打開都會重新載入，並非上一次搜索的結果
    const onVisibleChange = async (visible) => {
      if (visible) {
        await remoteSearch('')
      }
      emit('visibleChange', visible)
    }

    onMounted(async () => {
      await remoteSearch('')
    })

    return { syncModel, loading, dataList, remoteSearch, getDataList, onVisibleChange }
  },

  methods: {
    getValue (item) {
      if (this.objKey) return item[this.objKey]
      else return item
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-select  {
  height: 100% !important;
}
::v-deep .el-input  {
  height: 100% !important;
}

::v-deep .el-select__tags {
@apply flex-nowrap;
}

::v-deep .el-select__tags .el-tag {
  @apply max-w-[120px];
}
</style>
